import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import QRCode from "react-qr-code";
import StudentInfo from "../FeeSystem/StudentInfo";
import moment from "moment";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import { calculateColumnTotal, getMonthName } from "../General/Utility";

import { toast, ToastContainer } from "react-toastify";

const PrintCollectionReportDetail = () => {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);

  const [totalDeposit, settotalDeposit] = useState("");
  const [Banch, setBanch] = useState(1);
  const [Startdate, setStartdate] = useState("");

  const [Reappear, setReappear] = useState("false");

  // pagination
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [TotalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    document.title = "AGS School Management System";

    setLoading(true);
    // Get the URL parameters
    const urlParams = new URLSearchParams(window.location.search);

    // Retrieve individual parameter values
    // const banch = urlParams.get("banchNo");
    const startDate = urlParams.get("startDate");
    const banch = urlParams.get("benchNo");
    //console.log(banch,startDate);
    setBanch(banch);
    setStartdate(moment(startDate).format(config.date_format));

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      StartDate: startDate,
      BenchNo: banch,
      pageNo: 1,
      pageSize: 10000,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "FeeSystem/GetCollectionReportHeadWise",

      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    //console.log(data);
    axios(api_config)
      .then(function (response) {
        //console.log(response.data);
        if (response.data.status_code == 1) {
          setLedger(response.data.ListofRecords);
          setTotalRecords(response.data.totalRecords);
          settotalDeposit(response.data.TotalReceived);
          setLoading(false);
          //console.log(listOfLedger);
        }
      })
      .catch(function (error) {
        toast.error("Network Error..", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }, []);

  const renderLedger = () => {
    if (listOfLedger.length > 0) {
      return listOfLedger.map((item, index) => {
        return (
          <tr key={index}>
            <td>{item.Selected_Student.Status_Type_Id}</td>
            <td>{moment(item.ReceivedDate).format(config.date_format)}</td>
            <td>{item.Selected_Student.Registration_No}</td>
            <td>{item.Selected_Student.Student_Name}</td>
            <td>{item.FeeCode} - {item.ConcessionCode}</td>
            <td>{item.Description}</td>
            <td>{moment(item.PostingDate).format("MMM YYYY")}</td>
            <td>{item.ReceiptRef}</td>
            <td>{item.ReceivedAmount}</td>
            <td>{item.BusRoute_Code}</td>
            {/* <td className="text-center">
                        {grp_id == 1 || grp_id == 10 ? (
                            <ul
                                className="inline-action"
                                aria-labelledby="dropdownMenuButton1"
                            >
                                <li>
                                    <button
                                        onClick={(e) =>
                                            deleteScrollEntry(item.Entry_Id)
                                        }
                                        className={`red`}
                                    >
                                        <i className="ri-delete-bin-line"></i>
                                    </button>
                                </li>
                            </ul>
                        ) : (
                            ""
                        )}
                    </td> */}

          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="9">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };

  return (
    <>
      <ToastContainer />

      <Page orientation="portrait" size="a4">
        <table className="table table-sm table-bordered table-print">
          <thead>
            <tr>
              <th colSpan={20}>
                <PrintHeader
                  title={`Collection Report For Bench No ${Banch} and Date ${Startdate}`}
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td className="text-center" colSpan="8">
                  <Spinner animation="border" role="status"></Spinner>
                </td>
              </tr>
            ) : (
              <>
                <tr>
                  <th>Bench No</th>
                  <th>Dated</th>
                  <th>Registration No</th>
                  <th>Student Name</th>
                  <th>Class</th>
                  <th>Fee Name</th>
                  <th>Month</th>
                  <th>Receipt No.</th>
                  <th>Amount Deposited</th>
                  <th>Bank</th>
                </tr>
                {renderLedger()}
                <tr>
                  <td colSpan={7}></td>
                  {/* <td></td> */}
                  <td >
                    <b>Total </b>
                  </td>
                  <td>
                    <b>{totalDeposit}</b>
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </Page>
    </>
  );
};

export default PrintCollectionReportDetail;
